import { Client, fetchExchange } from "urql"

import { HISTORY_CUTOFF } from "../settings"

export const goldsky = new Client({
  url: "https://ao-search-gateway.goldsky.com/graphql",
  exchanges: [fetchExchange],
})

export const AO_MIN_INGESTED_AT = `ingested_at: { min: ${HISTORY_CUTOFF} }`
